// extracted by mini-css-extract-plugin
export default {"list":"yqYgE9pv5z"};